//#region src/bite_log_pusher_event.ts
var BiteLogPusherEvent = /* @__PURE__ */ function(BiteLogPusherEvent) {
	BiteLogPusherEvent[BiteLogPusherEvent["Ok"] = 0] = "Ok";
	BiteLogPusherEvent[BiteLogPusherEvent["Connected"] = 1] = "Connected";
	BiteLogPusherEvent[BiteLogPusherEvent["Subscribed"] = 2] = "Subscribed";
	BiteLogPusherEvent[BiteLogPusherEvent["Disconnected"] = 3] = "Disconnected";
	BiteLogPusherEvent[BiteLogPusherEvent["FailedToConnect"] = 4] = "FailedToConnect";
	BiteLogPusherEvent[BiteLogPusherEvent["FailedToSubscribe"] = 5] = "FailedToSubscribe";
	BiteLogPusherEvent[BiteLogPusherEvent["Error"] = 6] = "Error";
	BiteLogPusherEvent[BiteLogPusherEvent["Initialized"] = 7] = "Initialized";
	return BiteLogPusherEvent;
}(BiteLogPusherEvent || {});
//#endregion
export { BiteLogPusherEvent };

//# sourceMappingURL=bite_log_pusher_event.js.map